module.exports = __webpack_public_path__ + "static/media/fi.1439b028.svg";